import React from 'react';
import dayjs from 'dayjs';
import { Button, Spinner, Table } from 'react-bootstrap';
import { FaTimesCircle } from 'react-icons/fa';
import { EmployeeConfigMaster } from "../../../models/config/EmployeeConfigMaster";
import { useCompanyMaster } from "../../../queries";

export type EmployeeConfigMasterTableProps = {
    employeeConfigs?: EmployeeConfigMaster[];
    isPending?: boolean;
    onDelete?: (employeeConfigs: EmployeeConfigMaster) => void;
};

export const EmployeeConfigMasterTable = (
    props: EmployeeConfigMasterTableProps
) => {
    const { isPending, employeeConfigs, onDelete } = props;

    const { data: companyMaster } = useCompanyMaster()
    const companyMasterMap = new Map(companyMaster?.map(company => [company.sid, company]));

    return (
        <div className="mt-3">
            <Table className="table-bordered table-hover custom-table-list table-responsive-lg" size="sm">
                <thead>
                    <tr style={{ width: '100%' }} className="text-center table-active thead-light require-field">
                        <th style={{ width: '5%', top: -1, position: 'sticky', zIndex: 1 }} />
                        <th style={{ top: -1, position: 'sticky', zIndex: 1 }}>Employee ID</th>
                        <th style={{ top: -1, position: 'sticky', zIndex: 1 }}>Company</th>
                        <th style={{ top: -1, position: 'sticky', zIndex: 1 }}>Company Code</th>
                        <th style={{ top: -1, position: 'sticky', zIndex: 1 }}>Role Access</th>
                        <th style={{ top: -1, position: 'sticky', zIndex: 1 }}>Create By</th>
                        <th style={{ top: -1, position: 'sticky', zIndex: 1 }}>Create On</th>
                    </tr>
                </thead>
                <tbody>
                    {isPending ? (
                        <tr>
                            <td colSpan={7} style={{ background: "rgba(209, 250, 221, 1)", color: "black", fontSize: '10pt', textAlign: "center" }}>
                                <Spinner animation="border" size="sm" />{' '}Loading...
                            </td>
                        </tr>
                    ) : !employeeConfigs?.length ? (
                        <tr>
                            <td colSpan={7} style={{ background: "#b7b7a4", color: "black", fontSize: '10pt', textAlign: "center" }}>No Data.</td>
                        </tr>
                    ) : (
                        employeeConfigs.map((employeeConfig, index) => {
                            const formattedCreatedOn = employeeConfig.created_on
                                ? dayjs(employeeConfig.created_on, 'YYYYMMDDHHmmss').format('DD/MM/YYYY HH:mm น.')
                                : undefined;

                            return (
                                <tr key={employeeConfig.id + index}>
                                    <td className="text-center" style={{ width: '5%' }}>
                                        <Button
                                            size="sm"
                                            variant="danger"
                                            onClick={() => onDelete?.(employeeConfig)}
                                        >
                                            <FaTimesCircle />
                                        </Button>
                                    </td>
                                    <td>{employeeConfig.id}</td>
                                    <td className="text-center">
                                        {employeeConfig.sid !== '*'
                                            ? companyMasterMap.get(employeeConfig.sid)?.company_name
                                            : "*"}
                                    </td>
                                    <td className="text-center">{employeeConfig.company_code}</td>
                                    <td>{employeeConfig.role_access}</td>
                                    <td>{employeeConfig.created_by}</td>
                                    <td>{formattedCreatedOn}</td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </Table>
        </div>
    );
};
